var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80973 2.84955C0.382098 5.37115 0.878952 8.04978 0.878952 16.1874C0.878952 22.9451 -0.30011 29.7195 5.87065 31.3144C7.79757 31.8099 24.8708 31.8099 26.7951 31.3118C29.3644 30.6489 31.4547 28.5649 31.7405 24.9312C31.7804 24.4241 31.7804 7.95968 31.7392 7.44223C31.4354 3.57166 29.0529 1.34097 25.9134 0.889169C25.1939 0.784907 25.0497 0.754015 21.3581 0.747579C8.26353 0.754015 5.39311 0.17092 2.80973 2.84955Z",
    fill: "url(#paint0_linear_0_1944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3225 4.78805C11.6487 4.78805 7.21054 4.37229 5.51531 8.72297C4.81508 10.5199 4.91677 12.8535 4.91677 16.1951C4.91677 19.1273 4.82281 21.8832 5.51531 23.6659C7.20667 28.0192 11.6809 27.6021 16.3199 27.6021C20.7955 27.6021 25.41 28.0681 27.1259 23.6659C27.8274 21.851 27.7244 19.5521 27.7244 16.1951C27.7244 11.7388 27.9703 8.86199 25.8091 6.70209C23.6209 4.51388 20.6616 4.78805 16.3174 4.78805H16.3225ZM15.3005 6.84368C25.0496 6.82823 26.2905 5.74443 25.6057 20.8006C25.3624 26.1257 21.3078 25.5413 16.3238 25.5413C7.23628 25.5413 6.97498 25.2813 6.97498 16.1899C6.97498 6.99299 7.6958 6.84883 15.3005 6.84111V6.84368ZM22.4109 8.73713C21.6553 8.73713 21.0426 9.34983 21.0426 10.1054C21.0426 10.861 21.6553 11.4737 22.4109 11.4737C23.1665 11.4737 23.7792 10.861 23.7792 10.1054C23.7792 9.34983 23.1665 8.73713 22.4109 8.73713ZM16.3225 10.3371C13.0878 10.3371 10.4658 12.9604 10.4658 16.1951C10.4658 19.4298 13.0878 22.0518 16.3225 22.0518C19.5572 22.0518 22.1779 19.4298 22.1779 16.1951C22.1779 12.9604 19.5572 10.3371 16.3225 10.3371ZM16.3225 12.3927C21.349 12.3927 21.3554 19.9974 16.3225 19.9974C11.2973 19.9974 11.2896 12.3927 16.3225 12.3927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1944",
    x1: 2.86897,
    y1: 29.6669,
    x2: 31.5802,
    y2: 4.81763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.8924,
    height: 30.8924,
    fill: "white",
    transform: "translate(0.878906 0.747559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.5cb3677efd41c32ae0d55cc1eac32b38.svg";
export { ForwardRef as ReactComponent };